module.exports = __webpack_public_path__ + "img/uk_failure_1.9e978b5b.png";